export default {
  cardInfoContainer: {
    display: "flex",
    justifyContent: "start",
    margin: "2rem 0 0 0",
  },

  baseTypeStyle: {
    fontFamily: "roboto",
    color: "white",
    padding: "0.25rem",
    width: "40%",
    textAlign: "center" as "center",
    borderRadius: "15%",
    margin: "0.5rem",
    background: "black",
  },
};
